import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DoctorDesignPage } from './doctor-design.page';

const routes: Routes = [
  {
    path: '',
    component: DoctorDesignPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DoctorDesignPageRoutingModule {}
